import React from 'react';
import Upload from 'rc-upload';
import config from '../config';
import Auth from '../services/Auth';

class FileUploader extends React.Component {    
    static defaultProps = {
        onError: () => { },
        onSuccess: () => { },
        onProgress: () => { },
        onStart: () => { }
    }

    abort = (file) => {

    }

    onStart = (file) => {
        this.props.onStart({
            key: file.uid,
            cancelMethod: this.uploader.abort.bind(this, file),
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type
        })
    }
    
    onSuccess = (response, file) => {
        this.props.onSuccess({
            key: file.uid,
            fileRecordId: response
        });
    }

    onError = (err, response, file) => {
        this.props.onError({
            key: file.uid,
            err,
            response,
        });
    }

    onProgress = (progressEvent, file) => {
        this.props.onProgress({
            key: file.uid,
            total: progressEvent.total,
            current: progressEvent.loaded,
            percent: Number(progressEvent.percent.toFixed(2))
        });
    }
    
    render() {
        return (
            <Upload ref={ref => this.uploader = ref}
                action={config.filesEndpoint}
                data={{sessionKey: Auth.getSessionKey()}}
                onSuccess={this.onSuccess}
                onError={this.onError}
                onProgress={this.onProgress}
                onStart={this.onStart}
                component="span"
            >
                {this.props.children}
            </Upload>
        );
    }

}

export default FileUploader;